export const Logo = () => {
    return <img src="/Bonisoft_logo_colour_iceblue_white.png" width="100%"/>;
};